import { useTranslation } from "react-i18next";
import { parallaxImage } from "../../../assets";
import StoreBadges from "../../../components/ui/StoreBadges";

function ParallaxSection() {
  const { t } = useTranslation();

  return (
    <div
      className="hidden sm:flex sm:items-center sm:justify-center sm:relative sm:h-[60vh] sm:bg-fixed sm:bg-cover"
      style={{ backgroundImage: `url(${parallaxImage})` }}
    >
      <div className="qa-head text-white flex flex-col justify-center items-center text-center h-[100%] w-[100%] sm:absolute sm:top-[0]">
        <div className="qa-container sm:bg-gradient-to-b sm:from-customPurple-light shadow-customPurple-light shadow-custom-rounded p-6 rounded-2xl w-[50%] sm:backdrop-blur-md">
          <div className="qa-title text-4xl font-euc py-6">
            <h2
              style={{
                textShadow: "0 0 15px #ddd, 0 0 20px #8B5CF6",
              }}
            >
              {t("parallax.title")}
            </h2>
          </div>

          <StoreBadges />
        </div>
      </div>
    </div>
  );
}

export default ParallaxSection;
